import { DermloopLearnReportTypeSubjectEnum } from '@dermloop/static-values';
import { Exclude } from 'class-transformer';
import { IsEnum, IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { BaseCreateDto, BaseUpdateDto } from '../base.dto';
import { NamedEntityDto } from '../clinical-details';
import type { LearnReportDto } from './learn-report.dtos';

export interface LearnReportTypeDto extends NamedEntityDto {
  adminNote?: string;
  subject: DermloopLearnReportTypeSubjectEnum;
  reports?: LearnReportDto[];
}

export class CreateLearnReportTypeDto
  extends BaseCreateDto
  implements Partial<LearnReportTypeDto>
{
  @IsNotEmpty()
  @IsString()
  name: string;

  @IsOptional()
  @IsString()
  name_da?: string;

  @IsOptional()
  @IsString()
  name_de?: string;

  @IsOptional()
  @IsString()
  adminNote?: string;

  @IsEnum(DermloopLearnReportTypeSubjectEnum)
  subject: DermloopLearnReportTypeSubjectEnum;

  @Exclude()
  reports?: never[];
}

export class UpdateLearnReportTypeDto
  extends BaseUpdateDto
  implements Partial<LearnReportTypeDto>
{
  @IsOptional()
  @IsNotEmpty()
  @IsString()
  name?: string;

  @IsOptional()
  @IsString()
  name_da?: string;

  @IsOptional()
  @IsString()
  name_de?: string;

  @IsOptional()
  @IsString()
  adminNote?: string;

  @Exclude()
  subject?: never;

  @Exclude()
  reports?: never[];
}
